export default __webpack_public_path__ + "codered_favicon.ico";